export const recipientsSelector = state => state.messaging.recipients.items;



// WEBPACK FOOTER //
// ./src/modules/messaging/selectors/recipients.js